import Model from './model.js'

export default {
	ReadUserList: function (params) {
		Model.ReadUserList(params)
	},
	ReadUserBot: function (params) {
		Model.ReadUserBot(params)
	},
	ReadUserChatSummary: function(params) {
		Model.ReadUserChatSummary(params)
	},
	ReadChatMessage: function (params) {
		Model.ReadChatMessage(params)
	},
	RegisterChatMessage: function (params) {
		Model.RegisterChatMessage(params)
	},
}




// WEBPACK FOOTER //
// ./src/App/chat/ChatSidebar/presenter.js